import { render } from "./IconBedTimeUp.vue?vue&type=template&id=1d4c6376"
import script from "./IconBedTimeUp.vue?vue&type=script&lang=js"
export * from "./IconBedTimeUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__